<template>
    <div class="Algolia mb-8">
        <div class="container relative z-10 flex items-start justify-center mb-8 lg:hidden">
            <button
                class="px-4 h5 text-white outline-none"
                :class="{ 'opacity-50': selectedIndex !== productsIndex }"
                @click="selectedIndex = productsIndex"
            >
                Listings
            </button>
            <button
                class="px-4 h5 text-white outline-none"
                :class="{ 'opacity-50': selectedIndex !== pagesIndex }"
                @click="selectedIndex = pagesIndex"
            >
                Pages
            </button>
        </div>

        <Listings
            v-if="selectedIndex === productsIndex"
            :products-index="productsIndex"
            :pages-index="pagesIndex"
            @switch="updateIndex"
        />

        <Pages
            v-if="selectedIndex === pagesIndex"
            :products-index="productsIndex"
            :pages-index="pagesIndex"
            @switch="updateIndex"
        />
    </div>
</template>

<script>
import Listings from '@/Listings.vue';
import Pages from '@/Pages.vue';

export default {
    components: {
        Listings,
        Pages
    },

    data() {
        return {
            selectedIndex: `products_${this.$root.hub}`,
            productsIndex: `products_${this.$root.hub}`,
            pagesIndex: `pages_${this.$root.hub}`,
            query: ''
        };
    },

    methods: {
        updateIndex(value) {
            this.selectedIndex = value;
        }
    }
};
</script>

<style scoped>
.subitem-wrapper:before,
.subitem-wrapper:after {
    margin: auto;
    content: '';
}
</style>
